import React from 'react'
import { formatDecimalNumber, formatDurationHMS } from 'utils/commonFun'

const SolarConsumption = ({ SolarConsumptionData, graphData }) => {
  // console.log('SolarConsumptionData', SolarConsumptionData)
  return (
    <div className="_card">
      <div className="power_units">
        {/* {graphData ?
          (<ul>
            <li>
              <span>Total Generation</span>
              <b>{formatDecimalNumber(SolarConsumptionData?.totalGeneration)} KW</b>
            </li>
            <li>
              <span>GO Duration</span>
              <b>{formatDurationHMS(SolarConsumptionData?.totalGoDuration)}</b>
            </li>
            <li>
              <span>GA Duration</span>
              <b>{formatDurationHMS(SolarConsumptionData?.totalDuration)}</b>
            </li>
            <li>
              <span>PA Duration</span>
              <b>{formatDurationHMS(SolarConsumptionData?.totalPaDuration)}</b>
            </li>
          </ul>)
          :( */}
          <ul>
            <li>
              <span>Solar</span>
              <b>{formatDecimalNumber(SolarConsumptionData?.totalSolar)} kWh</b>
            </li>
            <li>
              <span>Grid</span>
              <b>{formatDecimalNumber(SolarConsumptionData?.totalGridDuration)} kWh</b>
            </li>
            <li>
              <span>DG</span>
              <b>{formatDecimalNumber(SolarConsumptionData?.totalDgDuration)} kWh</b>
            </li>
            <li>
              <span>Consumption</span>
              <b>{formatDecimalNumber(SolarConsumptionData?.totalConsumption)} kWh</b>
            </li>
          </ul>
         {/* )} */}
      </div>
    </div>
  )
}

export default SolarConsumption